import { Section } from '@pkdigital/pkd-custom-components';
import { TFunction } from 'i18next';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { RoundedImageCard } from './RoundedImageCard';
import { Branding } from '../../types';
import { useBranding } from '../../hooks/useBranding';
import { HugDiscountBadge } from '../badge/hug-discount/HugDiscountBadge';

const getImageCardDatasets = (t: TFunction) => {
  return [
    {
      headline: t('imageCardsSection.cards.c1.title'),
      description: t('imageCardsSection.cards.c1.content'),
      img: '/td-home/images/landingpage/personen-im-garten-md.png'
    },
    {
      headline: t('imageCardsSection.cards.c2.title'),
      description: t('imageCardsSection.cards.c2.content'),
      img: '/td-home/images/landingpage/working-laptop.png'
    },
    {
      headline: t('imageCardsSection.cards.c3.title'),
      description: t('imageCardsSection.cards.c3.content'),
      img: '/td-home/images/landingpage/man-with-tablet.png'
    }
  ];
};

const RoundedImageCardsSection: React.FC = () => {
  const { t } = useTranslation();
  const branding: Branding = useBranding();

  return (
    <Section className={`image-cards-section ${branding === 'hug' ? 'blue' : ''}`}>
      <Container>
        <Section headline={t('imageCardsSection.title')}>
          <Row className={'image-card-wrapper position-relative'}>
            {getImageCardDatasets(t).map((imageCard, index) => (
              <Col key={index} id={imageCard.headline} md={4}>
                <RoundedImageCard data={imageCard} />
              </Col>
            ))}
            {branding === 'hug' && <HugDiscountBadge imageSize={{ width: 135, height: 135 }} />}
          </Row>
        </Section>
      </Container>
    </Section>
  );
};

export { RoundedImageCardsSection };
